<template>
  <div class="product bps" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up" v-if="lang === 'pl'">Kompleksowa ochrona ptaków wokół morskich farm wiatrowych</div>
        <div class="heading-text" data-aos="fade-up" v-if="lang !== 'pl'">Comprehensive protection of birds around offshore wind farms</div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
                  Bioseco Spółka Akcyjna realizuje projekt z udziałem wsparcia UE pod tytułem:
                  „Kompleksowa ochrona ptaków wokół morskich farm wiatrowych - implementacja sztucznej inteligencji w rozproszonej sieci sensorów”.
                  <br />
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                    Celem modułu B+R jest realizacja prac badawczych, nad pierwszym w Polsce systemem ochrony awifauny na morskich farmach wiatrowych opartym na rozproszonej sieci sensorów, połączonych oprogramowaniem opartym na algorytmach sztucznej inteligencji. Badania umożliwia opracowanie prototypu rozwiązania – urządzenia do detekcji ptaków w ekstremalnie trudnych warunkach morskich, zapobiegających kolizjom elektrowni z ptakami. 
                    Efektem prac będzie system ochrony ptaków: Offshore Bird Protection System.
                    Grupą docelowe rozwiązania są inwestorzy i operatorzy farm wiatrowych na morzu.
                    <br />
                  </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                    Efekty projektu będą komercjalizowane poprzez uczestnictwo w targach na rynkach zagranicznych, w ramach modułu Internacjonalizacja.
                    <br />
                  </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                    Projekt współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach programu: Fundusze Europejskie dla Nowoczesnej Gospodarki, <br/>
                    Priorytet 1: „Wsparcie dla przedsiębiorców”<br/>
                    Działanie: Ścieżka SMART<br/>
                    Umowa o dofinansowanie nr FENG.01.01-IP.02-0673/24
                    <br/><br/>
                  </span>
              </li>
              <li>
                <span class="text">
                  <br/>
                  Wartość projektu:<br/>
                  21 537 216,50 zł
                  <br/><br/>
                  Dofinansowanie projektu ze środków UE:<br/>
                  14 333 627,00 zł
                </span>
              </li>
            </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
                  Bioseco Spółka Akcyjna is implementing a project with the support of the European Union entitled:
                  “Comprehensive protection of birds around offshore wind farms – implementation of artificial intelligence in a distributed sensor network.”
                  <br />
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                  The objective of the R&D module is to carry out research work on the first system in Poland for the protection of avifauna at offshore wind farms, based on a distributed network of sensors integrated with software using artificial intelligence algorithms. The research will enable the development of a prototype solution - a device for detecting birds in extremely challenging offshore conditions, aimed at preventing collisions between wind turbines and birds.
                  The outcome of the work will be a bird protection system: Offshore Bird Protection System.
                  The target group for the solution consists of investors and operators of offshore wind farms
                    <br />
                  </span>
                </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                  The project results will be commercialized through participation in international trade fairs as part of the Internationalization module.
                    <br />
                  </span>
                </li>
                <li>
                <span class="dot"></span>
                <span class="text">
                  The project is co-financed by the European Regional Development Fund under the programme: European Funds for Smart Economy,<br/>
                  Priority 1: „Support for entrepreneurs”<br/>
                  Measure: SMART Path<br/>
                  Grant agreement no. FENG.01.01-IP.02-0673/24
                    <br/><br/>
                  </span>
                </li>
              <li>
                <span class="text">
                  <br/>
                  Project value:<br/>
                  PLN 21 537 216,50
                  <br/><br/>
                  EU funding for the project:<br/>
                  PLN 14,333,627.00
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/store';
import FooterMain from '../components/FooterMain';
import FooterMoreInformation from '../components/FooterMoreInformation';
import VideoBox from '../components/VideoBox';
import Counter from '../components/Counter';
import smoothScroll from '../helpers/SmoothScroll';

export default {
  name: 'farms-product',
  components: {
    FooterMain,
    FooterMoreInformation,
    VideoBox,
    Counter
  },
  data: function () {
    return {
      circleValues: [
        {
          before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
        },
      ]

    }
  },
  computed: {
    lang: () => {
      return store.state.lang;
    },
    isPageContrasted() {
      return store.state.isPageContrasted
    },
    isFontBigger() {
      return store.state.isPageFontBigger
    },
    smoothScroll: () => smoothScroll
  },

  methods: {},
  mounted: function () {
    store.state.isAccessibilityVisible = true;
  },
  destroyed: function () {
    store.state.isAccessibilityVisible = false;
  },
}
</script>

<style>
.bps header.page-header .heading-text {
  max-width: 1200px !important;
}

.product .why-us-solution .elements .element.bps .text-box {
  float: left;
  max-width: initial;
  margin-top: 20px;
  margin-bottom: 100px;
}

.product .why-us-solution .elements .element.bps .text-box ul li .text {
  margin-top: -20px;
}


.ue {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
}

.ue img {
  max-width: 940px;
  width: 35%;
}

.product.contrasted {
  background: #000;
  color: yellow;
}

.product.contrasted .heading-text {
  color: yellow;
}

.product.contrasted .ue {
  background: #000;
}

.product.contrasted header a {
  color: yellow;
  background: #000;
}

.product.contrasted .btn {
  color: yellow;
  background: #000;
}

.product.fontBigger .why-us-solution .elements .element .text-box ul li .text {
  font-size: 1.6em;
  line-height: 1.6em;
}


</style>



// WEBPACK FOOTER //
// Offshore.vue?3370ae55